import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
// import { CourseService } from 'src/app/services/course.service';
// import { Marks, Result } from 'src/app/models/evaluation.model';
// import { Store } from 'store';
// import { User, VisitedCourse } from 'src/app/models/user.model';
// import { Course } from 'src/app/models/course.model';
// import { UtilityService } from 'src/app/services/utility.service';
import { forkJoin } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { ScoreFaqModalComponent } from '../score-faq-modal/score-faq-modal.component';
// import { ScoreFaqModalV2Component } from '../score-faq-modal-v2/score-faq-modal-v2.component';
// import { config } from 'src/app/config';
import { Router } from '@angular/router';
import { Marks, Result } from '../../models/evaluation.model';
import { User, VisitedCourse } from '../../models/user.model';
import { CourseService } from '../../services/course.service';
import { Store } from 'src/app/core/store/store';
import { UtilityService } from '../../utils/utility.service';
import { Course } from '../../models/course.model';
import { config } from 'src/app/configs/config';
import { ScoreFaqModalV2Component } from '../score-faq-modal-v2/score-faq-modal-v2.component';
import { ScoreFaqModalComponent } from '../score-faq-modal/score-faq-modal.component';
import { HandleSubscription } from '../../utils/handle-subscription';

@Component({
  selector: 'app-exercise-container',
  templateUrl: './exercise-container.component.html',
  styleUrls: ['./exercise-container.component.css']
})
export class ExerciseContainerComponent extends HandleSubscription implements OnInit, AfterViewInit {
  @Input() id: string;
  @Input() templateName: string;
  modules: any[] = [];
  exercises: any[] = [];
  activeTab: boolean[] = [];
  activeInsights: string = 'PAnalysis'
  title: string;
  totalMarks: number = 0;
  totalInterests: number = 0;
  isLiked: number = 0;
  @Input() progress: number = 0;
  evaluationData: Marks;
  behaviourScore: Result[];
  quizScore: Result[];
  user: User;
  totalQuestions: any[];
  @Input() evaluationResult: any;
  exerciseId: string;
  showBack: boolean = false;
  showSlick: boolean = false;
  isV2: boolean = false;
  practiceScore: any[];
  assessmentScore: any[];
  evalData: any;
  currentCourse: any;
  gridResult: any = {
    SKILL: 'HIGH',
    EFFORT: 'MEDIUM',
    CONFIDENCE: 'LOW'
  };
  rows: any[] = [{ level: 'HIGH' }, { level: 'MEDIUM' }, { level: 'LOW' }];
  cells: any[] = [{ parameter: 'SKILL' }, { parameter: 'EFFORT' }, { parameter: 'CONFIDENCE' }];
  emojiReactions = {
    'HIGH': 'assets/images/emoticon-laugh.svg',
    'MEDIUM': 'assets/images/emoticon-smile.svg',
    'LOW': 'assets/images/emoticon-sad.svg'
  };
  @Output() currCourseExercises = new EventEmitter<any>();
  constructor(private courseService: CourseService, private store: Store, private utilityService: UtilityService, private modalService: NgbModal, private router: Router) { 
    super();
  }

  ngOnInit() {


    forkJoin([this.getUser(), this.getCourse()]).subscribe(results => {
      const user = results[0];
      const course = results[1];
      if (user) {

        this.user = user;
        // this.currentCourse = this.user.visitedCourses.find(vc => vc.id == this.id);
        this.store.select('currentUserCourse').pipe(takeUntil(this.unsubscribe$)).subscribe((course: any) => {
          if(course) {
            this.currentCourse = course;
          }
        });
      }
      if (course) {
        this.title = course.title;
        this.isV2 = course.courseTypeVersion == 2
        this.modules = course.contents.map(cnt => {
          let obj = {
            isQuiz: cnt.contentInfo.mediaType === 'HTML',
            file: cnt.contentInfo.mediaType !== 'HTML' ? cnt.contentInfo.url : null,
            title: cnt.contentInfo.title,
            id: cnt.contentInfo._id,
            mediaType: cnt.contentInfo.mediaType,
            type: cnt.contentInfo.type,
            duration: cnt.contentInfo.duration,
            image: cnt.contentInfo.image,
            moduleNumber: cnt.moduleNumber,
            moduleName: cnt.moduleName
          }
          return obj;
        });
      }


      if (user && course) {
        if (this.evaluationResult) {
          this.totalMarks = this.evaluationResult.courseProgress ? this.evaluationResult.courseProgress.totalPercentage : 0;
          this.evalData = this.evaluationResult.courseProgress;
          this.evaluationData = this.evaluationResult.marks;
          this.behaviourScore = Object.values(this.evaluationData.marksByRows);
          this.activeTab = Array(this.behaviourScore.length).fill(false);
          this.activeTab[0] = true;
          this.quizScore = Object.values(this.evaluationData.marksByExercise).filter(i => i.totalMarks);
          this.modules = this.modules.filter(m => m.isQuiz).map(i => ({ ...i, exerciseResult: this.getExerciseResult(i.id) }));
          if (this.evalData.isNewEvaluation && !this.isV2) {
            this.exercises = this.modules.filter(m => m.type == 'IPJ MILESTONE' || m.type == 'IPJ PRACTICE').sort((a, b) => a.type.localeCompare(b.type));
          } else if (this.isV2) {
            this.exercises = this.modules.filter(m => m.type == 'MILESTONE' || m.type == 'CHECKPOINT').sort((a, b) => a.type.localeCompare(b.type));
          } else {
            this.assessmentScore = this.modules.filter(m => m.type == 'IPJ MILESTONE');
            this.practiceScore = this.modules.filter(m => (m.type == 'IPJ PRACTICE' || m.type == 'PRIMER'));
          }
          this.setStatusExercises();
        } else {
          
          // this.practiceScore = this.user.visitedCourses.find(el => el.id == this.id).exercises.map(el => {
          this.practiceScore = this.currentCourse.exercises.map(el => {
            let obj: any;
            obj = {
              exerciseId: el.id,
              exerciseName: this.getExerciseName(el.id)
            }
            return obj;
          });
        }
      }
    });
  }

  getLevel(marks,total) {
    if(total){
      let percentage = (marks/total)*100;
      if(percentage >= 75) return "HIGH"
      if(percentage >= 50 && percentage <= 74) return "MEDIUM"
      if(percentage <= 49) return "LOW"
    }
    return null;
  } 

  getRowResult(score){
    this.gridResult['SKILL'] = this.getLevel(score.skillMarks,score.skillTotalMarks);
    this.gridResult['EFFORT'] = this.getLevel(score.effortMarks,score.effortTotalMarks);
    this.gridResult['CONFIDENCE'] = this.getLevel(score.confidenceMarks,score.confidenceTotalMarks);
    return this.gridResult;
  }
  activeBehaviourTab(j) {
    for (let i = 0; i < this.activeTab.length; i++)
      this.activeTab[i] = false;
    this.activeTab[j] = true;
  }

  getUser() {
    return this.store.select<User>('user').pipe(first());
  }

  getCourse() {
    return this.store.select<Course>('course').pipe(first());
  }

  getExerciseResult(exid) {
    if (exid && this.quizScore.length) {
      let i = this.quizScore.findIndex(ex => ex.exerciseId == exid);
      if (i > -1) {
        return { gainedMarks: Math.round(this.quizScore[i].gainedMarks), totalMarks: Math.round(this.quizScore[i].totalMarks), timeSpent: this.getExerciseProperty(exid, 'timeSpent'), status: this.getExerciseProperty(exid, 'timeSpent'), assessmentType: this.getExerciseProperty(exid, 'assessmentType') }
      }
    }
    return null
  }

  getExerciseProperty(exerciseId, property) {
    if (exerciseId && this.currentCourse) {
      let currentExerciseIndex = this.currentCourse.exercises.findIndex(el => el.id === exerciseId);
      if (currentExerciseIndex >= -1) {
        return this.currentCourse.exercises[currentExerciseIndex][property]
      }
    }
    return null;
  }
  openScoreFaqModal() {
 
    if (this.isV2){
      const modalRef = this.modalService.open(ScoreFaqModalV2Component, {
        windowClass: 'modal-cntrl modal-cntrl-lg'
      });
      modalRef.componentInstance.isV2Assessment = this.isV2;
    }else{
      const modalRef = this.modalService.open(ScoreFaqModalComponent, {
        windowClass: 'modal-cntrl modal-cntrl-lg'
      });
    }
      
  }

  getExerciseRows(exId) {
    if (exId) {
      let rowsInExercise = Object.keys(this.evaluationData.marksByExercise[exId]);
      let exerciseRows = [];
      rowsInExercise.forEach(el => {
        let index = Object.keys(this.evaluationData.marksByRows).indexOf(el);
        if (index > -1) {
          exerciseRows.push(this.evaluationData.marksByRows[el])
        }
      });
      return exerciseRows;
    }
  }

  getExerciseName(id) {
    if (id) {
      let module = this.modules.find(el => el.id === id);
      if (module) {
        return module.title;
      }
    }
  }

  getExerciseDetails(exerciseId) {
    if (exerciseId && this.currentCourse) {
      let currentExerciseIndex = this.currentCourse.exercises.findIndex(el => el.id === exerciseId);
      if (currentExerciseIndex >= -1) {
        return this.currentCourse.exercises[currentExerciseIndex]['timeSpent']
      }
    }
    return false;
  }


  getModuleName(id) {
    if (id) {
      let module = this.modules.find(el => el.id === id);
      if (module) {
        return module.moduleName;
      }
    }
  }

  ngAfterViewInit() {
    this.utilityService.showbackButton$.subscribe(res => {
      this.showBack = res;
    });
  }

  back() {
    this.utilityService.destroyResultComponent = true;
  }
  navigateToPlayer(id, type = 'HTML') {
    this.openPlayer(type, id);
  }

  openPlayer(type, id) {
    this.utilityService.setModuleNavigationData(type, id);
    if(this.user && this.user.organization && config.SAME_TAB_OPEN_ORG.includes(this.user.organization)) {
      this.router.navigate([`/player/${this.id}`]);
    } else {
      window.open(`/player/${this.id}`, '_blank');
    }
  }

  resumeCourse() {
    if(this.user && this.user.organization && config.SAME_TAB_OPEN_ORG.includes(this.user.organization)) {
      this.router.navigate([`/player/${this.id}`]);
    } else {
      window.open(`/player/${this.id}`, '_blank');
    }
  }

  /**
   * Set status in exercises to hide/show score awaited on exercise card
   */
  setStatusExercises() {
    for (let i = 0; i <  this.exercises.length; i++) {
      for (let j = 0; j < this.currentCourse.exercises.length; j++) {
        if(this.exercises[i].id == this.currentCourse.exercises[j].id) {                
          this.exercises[i]['status'] = this.currentCourse.exercises[j].status;
        }            
      }
      if(!this.exercises[i]['status']) {
        this.exercises[i]['status'] = '';
      }
    }
    this.currCourseExercises.emit(this.exercises);
  }




}
